import { MonitorView } from "@/services/backend/qpm/monitors/types/monitor-view";
import { useEffect, useState } from "react";
import { usePersistenceStateUpdateOnTrigger } from "@/shared/lib/persistence-state/persistence-state-info";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { useQpmMonitorDeleteMutation } from "@/services/backend/qpm/monitors/api/monitor-api";

type DeleteMonitorDialogProps = {
  monitor: MonitorView;
  onDeleteSuccess?: () => void;
};

export function DeleteMonitorDialogComponent({
  monitor,
  onDeleteSuccess,
}: DeleteMonitorDialogProps) {
  const [open, setOpen] = useState<boolean>(false);
  const [deleteMonitor, { error, isLoading, isSuccess, reset }] =
    useQpmMonitorDeleteMutation();
  const { onTrigger: triggerDelete } = usePersistenceStateUpdateOnTrigger(
    { id: monitor.id },
    deleteMonitor,
    isLoading,
    error,
    isSuccess,
    reset,
    { toastError: true, toastSuccess: true },
  );

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
    }
  }, [isSuccess, onDeleteSuccess]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive">{t("Löschen")}</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Monitor wirklich löschen?")}</DialogTitle>
          <DialogDescription>
            {t(
              "Dieser Vorgang kann nicht rückgängig gemacht werden. Der Monitor muss danach manuell erneut angelegt werden. Der Katalog bleibt unverändert, aber Aktualisierungen aus diesem Basis-Monitor funktionieren dort anschließend nicht mehr.",
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => setOpen(false)}
            disabled={isLoading}
          >
            {t("Abbrechen")}
          </Button>
          <Button
            variant="destructive"
            onClick={triggerDelete}
            disabled={isLoading}
          >
            {t("Löschen")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
